import { accountNumber, routingNumber } from "us-bank-account-validator";
import { stripNonDigits } from "./format";
import type { PaymentMethodFieldError } from "./card-payment-validation";

export function validateAchRoutingAndAccount(
  routingNumberValue: string,
  accountNumberValue: string,
): PaymentMethodFieldError | null {
  const routingDigits = stripNonDigits(routingNumberValue);

  if (!routingNumber(routingDigits).isValid) {
    return {
      path: ["routingNumber"],
      message: "Enter a valid routing number.",
    };
  }

  const accountNorm = stripNonDigits(accountNumberValue);

  if (!accountNumber(accountNorm).isValid) {
    return {
      path: ["accountNumber"],
      message: "Enter a valid account number (4-17 characters).",
    };
  }

  return null;
}

export function formatRouting(value: string): string {
  return stripNonDigits(value).slice(0, 9);
}

export function formatAccountNumber(value: string): string {
  return stripNonDigits(value).slice(0, 17);
}

export function isValidRoutingNumber(value: string): boolean {
  return routingNumber(stripNonDigits(value)).isValid;
}

const INITIALS_STOPWORDS: ReadonlySet<string> = new Set([
  "of",
  "and",
  "the",
  "&",
]);

export function bankInitials(name: string): string {
  const cleaned = name
    .trim()
    .replace(/[^a-zA-Z0-9 &]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (cleaned.length === 0) return "";

  const words = cleaned
    .split(" ")
    .filter((w) => w.length > 0 && !INITIALS_STOPWORDS.has(w.toLowerCase()));

  if (words.length === 0) return "";
  if (words.length === 1) {
    return (words[0] ?? "").slice(0, 2).toUpperCase();
  }
  const first = words[0]?.[0] ?? "";
  const second = words[1]?.[0] ?? "";
  return (first + second).toUpperCase();
}
